import { WebPlugin } from '@capacitor/core';
export class ApkInstallerWeb extends WebPlugin {
    async installApk() {
        throw this.unimplemented('Not implemented on web.');
    }
    async checkInstallPermission() {
        throw this.unimplemented('Not implemented on web.');
    }
    async requestInstallPermission() {
        throw this.unimplemented('Not implemented on web.');
    }
}
